import {
  CFormCheck,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useQueryClient, useMutation } from "react-query";
import { useToast } from "../../../hooks/useToast";
import { useCookie } from "../../../hooks/useCookie";
import apiService from "../../../service/apiService";
import { DELETE_ACTIONS } from "../../../config/constants";
import { general } from "../../../locales/general";
import { colors } from "../../../config/theme";
import EditIcon from "../../../components/icons/EditIcon";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import PromptModal from "../../../components/modals/PromptModal";
import { Link } from "react-router-dom";

function TableBodyRowContent({
  categoryTranslation,
  deletedList,
}: {
  categoryTranslation: CategoryTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteCategoryTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`category-translations/${id}`, token);
  });

  useEffect(() => {
    if (isChecked) {
      deletedList({ type: DELETE_ACTIONS.ADD, id: categoryTranslation.id });
    } else {
      deletedList({ type: DELETE_ACTIONS.REMOVE, id: categoryTranslation.id });
    }
  }, [deletedList, isChecked, categoryTranslation.id]);

  const removeCategoryTranslation = () => {
    deleteCategoryTranslation.mutate(categoryTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <CTableRow
      style={{
        borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className=" text-capitalize text-sm">
        <div className="d-flex align-items-center gap-3">
          <CFormCheck
            id="flexCheckDefault"
            label=""
            defaultChecked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            color={colors.yellow}
          />

          <div>{categoryTranslation.category?.label}</div>
        </div>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{categoryTranslation?.label}</span>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{categoryTranslation?.lang}</span>
      </CTableDataCell>

      <CTableDataCell>
        <Link to={`/category-translations/update/${categoryTranslation.id}`}>
          <EditIcon width="18" height="18" fill={colors.secondary} />
        </Link>{" "}
        <button
          className="outline-none border-0 bg-transparent"
          onClick={() => setShowModal(true)}
        >
          {deleteCategoryTranslation.isLoading ? (
            <CSpinner size="sm" />
          ) : (
            <DeleteIcon
              width="20"
              height="20"
              fill={colors.primary}
              className="ms-2"
            />
          )}
        </button>
      </CTableDataCell>
      <PromptModal
        open={showModal}
        onAccept={removeCategoryTranslation}
        onClose={() => setShowModal(false)}
      />
      {/* <CategoryTranslationModal
                onClose={() => setShowEditModal(false)}
                open={showEditModal}
                id={categoryTranslation?.id}
                name={categoryTranslation?.name}
                link={categoryTranslation?.link}
                logo={categoryTranslation?.logoImage}
            /> */}
    </CTableRow>
  );
}

interface TableProps {
  categoryTranslations: CategoryTranslation[];
  categoryTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function CategoryTranslationsTable({
  categoryTranslations,
  categoryTranslationsToBeDeleted,
}: TableProps) {
  return (
    <div className="mt-3">
      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Catégorie</CTableHeaderCell>
            <CTableHeaderCell scope="col">Traduction</CTableHeaderCell>
            <CTableHeaderCell scope="col">Langue</CTableHeaderCell>
            <CTableHeaderCell scope="col"></CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {categoryTranslations?.map((categoryTranslation) => (
            <TableBodyRowContent
              categoryTranslation={categoryTranslation}
              key={categoryTranslation?.id}
              deletedList={categoryTranslationsToBeDeleted}
            />
          ))}{" "}
        </CTableBody>
      </CTable>
    </div>
  );
}
